module.exports = __webpack_public_path__ + "static/media/camera-icon.dee104fc.svg";